import { cn } from "@/lib/utils";

type TColorProp = string | string[];

interface ShineBorderProps {
  borderRadius?: number;
  borderWidth?: number;
  duration?: number;
  color?: TColorProp;
  className?: string;
  children: React.ReactNode;
}

export function ShineBorder({
  borderRadius = 8,
  borderWidth = 1,
  duration = 14,
  color = "#000000",
  className,
  children,
}: ShineBorderProps) {
  const colorStr = Array.isArray(color) ? color.join(",") : color;
  return (
    <div
      style={{ borderRadius: `${borderRadius}px` }}
      className={cn("relative w-full", className)}
    >
      <div
        aria-hidden
        style={{
          borderRadius: `${borderRadius}px`,
          padding: `${borderWidth}px`,
          backgroundImage: `radial-gradient(transparent, transparent, ${colorStr}, transparent, transparent)`,
          backgroundSize: "300% 300%",
          WebkitMask:
            "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          WebkitMaskComposite: "xor",
          mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          maskComposite: "exclude",
          animation: `shine-pulse ${duration}s infinite linear`,
        }}
        className="pointer-events-none absolute inset-0 z-10"
      />
      {children}
    </div>
  );
}
